import { createBrowserHistory } from "history";
const history = createBrowserHistory({ basename: "" });
export default history;

export const goBack = () => {
  history.goBack();
};
